function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import get from 'lodash/get';
import { BusinessError } from "./../errors";
import { MtopException } from "./mtop/exception";
/**
 * Create a business exception interceptor
 */
function createException(options) {
  var _options$ErrorType;
  var exception = options.exception,
    handler = options.handler;
  var ErrorType = (_options$ErrorType = options.ErrorType) !== null && _options$ErrorType !== void 0 ? _options$ErrorType : BusinessError;
  return [exception && function (config) {
    var error = exception(config, ErrorType);
    if (!!error) return Promise.reject(error);
    return config;
  }, handler && function (e) {
    if (!(e instanceof ErrorType)) return Promise.reject(e);
    return handler(e);
  }];
}
var BusinessException = {
  exception: function exception(_ref, BError) {
    var response = _ref.data,
      config = _ref.config;
    // 确保返回数据中的success有最高优先级 -- 适配中台 DTO SDK
    var success = get(response, 'retSuccess', true);
    if (!success) {
      var _error = get(response, 'error') || get(response, 'message');
      return new BError(_error, response, config);
    }
    if (!!get(response, 'error') && typeof get(response, 'error') === 'string') {
      var _error2 = get(response, 'error');
      return new BError(_error2, response, config);
    }
    if (!!get(response, 'errorMsg')) {
      var _error3 = get(response, 'errorMsg');
      return new BError(_error3, response, config);
    }

    // https://aliyuque.antfin.com/set/gwbnt6/vh08xudu9y0bqakh#bjIHg
    if (get(response, 'errorCode', 0) !== 0 && !!get(response, 'errorMessage')) {
      var _error4 = get(response, 'errorMessage');
      return new BError(_error4, response, config);
    }
    return null;
  },
  handler: function handler(e) {
    var _e$config, _e$config2, _e$config3;
    if (e.type !== 'BusinessError' || !e.message) return Promise.reject(e);
    if ((_e$config = e.config) !== null && _e$config !== void 0 && _e$config.noErrorToast) return Promise.reject(e);
    if (((_e$config2 = e.config) === null || _e$config2 === void 0 ? void 0 : _e$config2.noErrorToast) === false || ((_e$config3 = e.config) === null || _e$config3 === void 0 ? void 0 : _e$config3.method) === 'post') {
      // only post request will show error toast
      if (window['BUSINESS_ERROR_HANDLER']) {
        window['BUSINESS_ERROR_HANDLER'](e);
      } else if (window['Next'].Message) {
        var _window$Next$Message$, _window$Next$Message;
        (_window$Next$Message$ = (_window$Next$Message = window['Next'].Message).error) === null || _window$Next$Message$ === void 0 || _window$Next$Message$.call(_window$Next$Message, {
          content: e.message
        });
      } else {
        var _console = console,
          _error5 = _console.error;
        _error5('[Business Error] Not found matched handler.');
        _error5(e);
      }
    }
    return Promise.reject(e);
  }
};
export var injectBusinessException = function injectBusinessException(axios) {
  return injectException(axios, BusinessException);
};
export var injectMtopException = function injectMtopException(axios) {
  return injectException(axios, MtopException);
};
export var injectException = function injectException(axios, options) {
  var _createException = createException(options),
    _createException2 = _slicedToArray(_createException, 2),
    fullfill = _createException2[0],
    reject = _createException2[1];
  var interceptors = axios.interceptors;
  // @ts-ignore
  var handlers = interceptors.response.handlers;
  fullfill && handlers.unshift({
    synchronous: false,
    runWhen: null,
    fulfilled: fullfill
  });
  var erejectId = reject && interceptors.response.use(undefined, reject);
  return function dispose() {
    if (fullfill) {
      var index = handlers.findIndex(function (item) {
        return item.fulfilled === fullfill;
      });
      if (index >= 0) {
        handlers.splice(index, 1);
      }
    }
    if (reject && typeof erejectId === 'number') {
      interceptors.response.eject(erejectId);
    }
  };
};